module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Light-Italic.ae75885c.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Light-Italic.otf
// module id = 3595
// module chunks = 68